import {useQuery, UseQueryResult, UseQueryOptions} from "react-query";
import {API, ApiResponseBase, CustomAxiosError} from "../../../logics/api-config";

export interface IPaymentMethod {
    code: string;
    label?: string;
    official_code: string;
}

async function doGet(): Promise<IPaymentMethod[]> {
    try {
        const response = await API.get(`/payment-methods/list`);
        const responseData = response?.data;
        console.log("Response data from API:", responseData);

        // Se responseData è un oggetto, convertilo in array
        if (responseData && typeof responseData === 'object' && !Array.isArray(responseData)) {
            return Object.values(responseData);
        }

        return responseData as IPaymentMethod[];
    } catch (error) {
        throw error as CustomAxiosError;
    }
}

const useApiGetPaymentMethods = (
    options?: Omit<UseQueryOptions<IPaymentMethod[], CustomAxiosError>, 'queryKey' | 'queryFn'>
): UseQueryResult<IPaymentMethod[], CustomAxiosError> => {
    return useQuery<IPaymentMethod[], CustomAxiosError>("getPaymentMethods", doGet, {
        staleTime: 15 * 60 * 1000,
        refetchOnWindowFocus: false,
        ...options,
    });
};

export default useApiGetPaymentMethods;